export default __webpack_public_path__ + "static/media/X_A2.bb26e539.webm";